/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

interface IAccountCustomerBalanceTileInfo {
    label?: string;
    value?: string;
    verbagePrefix?: string;
    verbagePostfix?: string;
    className?: string;
    error?: string;
}

export const ErrorComponent: React.FC<IAccountCustomerBalanceTileInfo> = ({ error }) => (
    <span className='ms-account-customer-balance-tile__error'>
        {error}
    </span>
);

export const CreditComponent: React.FC<IAccountCustomerBalanceTileInfo> = ({ verbagePrefix, verbagePostfix, value, className }) => {
    return (
        <div className={className}>
            {verbagePrefix}
            <span className='ms-account-customer-balance-tile__value'>
                {value}
            </span>
            {verbagePostfix}
        </div>
    );
};

export const InfoComponent: React.FC<IAccountCustomerBalanceTileInfo> = ({ label, value, className }) => (
    <div className={className}>
        <span className='ms-account-customer-balance-tile__label'>
            {label}
        </span>
        <span className='ms-account-customer-balance-tile__value'>
            {value}
        </span>
    </div>
);
